import type { DynamicTexture } from '@babylonjs/core/Materials/Textures/dynamicTexture';

/**
 * Update dynamic texture data.
 * @param texture - Dynamic texture.
 * @param sw - the width.
 * @param sh - the height.
 * @param data - the data.
 */
export const updateDynamicTexture = (
  texture: DynamicTexture,
  sw: number,
  sh: number,
  data: Uint8ClampedArray,
): void => {
  const canvasContext = texture.getContext();
  const imageData = canvasContext.getImageData(0, 0, sw, sh);
  imageData.data.set(data);
  canvasContext.putImageData(imageData, 0, 0);
  texture.update();
};
